import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class CBM2{

    addCbm2(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFCBMs.svc/RestService/AddCbm2",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getAllCBM2Filtro(context, param) {
        var t = context;     
        var controller = new Controller();
        var fechaActual = new Date().toISOString().slice(0, 10);
        var fecha_inicio = param.fechas?.[0] ? param.fechas[0].toISOString().slice(0, 10) : "2023-01-01";
        var fecha_fin = param.fechas?.[1] ? new Date(param.fechas[1].setDate(param.fechas[1].getDate() + 1)).toISOString().slice(0, 10) : new Date(new Date(fechaActual).setDate(new Date(fechaActual).getDate() + 1)).toISOString().slice(0, 10);
        var folio = param.folio || 0;

        console.log(fecha_inicio, fecha_fin, folio);
        return new Promise(function(resolve, reject) {
            const urlBase = store.getters.getUrlServicios;
            const url = `${urlBase}WCFCBMs.svc/RestService/GetAllFiltroCbm2/${encodeURIComponent(folio)}/${encodeURIComponent(fecha_inicio)}/${encodeURIComponent(fecha_fin)}`;
        
            apiClientToken.get(url)
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al obtener datos del servidor",
                        life: 3000
                    });
                    console.log(error);
                    reject(error);
                });
        });
    }

    getAllCBM2(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "/WCFCBMs.svc/RestService/GetAllCbm2")        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    GetCbm2PorUI(context, param) {
        var t = context;
        var controller = new Controller();
        var fechaActual = new Date().toISOString().slice(0, 10);
        var fecha_inicio = param.fechas?.[0] ? param.fechas[0].toISOString().slice(0, 10) : "2023-01-01";
        var fecha_fin = param.fechas?.[1] ? param.fechas[1].toISOString().slice(0, 10) : fechaActual;
        var folio = param.folio || 0;
        var ui = param.unidad.Unidad_informacion;
    
        const urlBase = store.getters.getUrlServicios;
        const url = `${urlBase}WCFCBMs.svc/RestService/GetCbm2PorUI/${encodeURIComponent(ui)}/${encodeURIComponent(folio)}/${encodeURIComponent(fecha_inicio)}/${encodeURIComponent(fecha_fin)}`;
    
        return new Promise(function(resolve, reject) {
            apiClientToken.get(url)
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al obtener datos del servidor",
                        life: 3000
                    });
                    console.log(error);
                    reject(error);
                });
        });
    }
    

    GetBienesCbm2(context,id){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFCBMs.svc/RestService/GetBienesCbm2/" + id)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    Delete(context,data){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFCBMs.svc/RestService/Delete" , data)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }
    
}